import Pill from "PFComponents/pill/pill";
import WarningIcon from "PFIcons/warning.svg";
import React from "react";
import { useTranslation } from "react-i18next";

const ExceptionsPill = () => {
  const { t } = useTranslation("auditPlanner");

  return (
    <Pill
      style={{
        background: "var(--WorkflowState-exception)",
        color: "#FFF",
        padding: "1px 8px 0px",
        alignItems: "baseline",
        marginLeft: 10
      }}
    >
      <WarningIcon width={15} height={13} viewBox="2 2 20 17" />
      {t("parts.exceptions")}
    </Pill>
  );
};

export default ExceptionsPill;
